import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { SessionService } from "../../../common/services/session.service";
import { UtilityService } from "../../../shared/utility.service";
import {
  IN_SearchByAlphabet,
  IN_VoterSearchByGeneralReq,
  IN_VoterSearchByPhoneReq,
  IN_VoterSearchByVoterIdReq,
} from "../../Interfaces/voter-search.Interface";
import { KaryakartaService } from "src/app/karyakarta/karyakartaService/api/karyakarta.service";
import { VoterSearchAPIService } from "../../services/api/api.service";
import { GLOBAL_CONSTANT } from "src/app/common/constant/global.constant";
declare var _: any;

@Component({
  selector: "app-voter-search-form",
  templateUrl: "./form.component.html",
  styleUrls: ["./form.component.scss"],
})
export class VoterSearchFormComponent implements OnInit {
  searchByAlphabet: IN_SearchByAlphabet;
  searchByVoterId: IN_VoterSearchByVoterIdReq;
  searchByGeneral: IN_VoterSearchByGeneralReq;
  searchByPhone: IN_VoterSearchByPhoneReq;
  genderTypes = GLOBAL_CONSTANT.GENDER_TYPES;
  Lastname1: string;
  officeId: any;
  subIndex: Number = 0;
  subIndex2: Number = 0;
  mainIndex: Number;
  data = {};
  selectedVisitor: any = {};
  VoterFlag: boolean = true;
  assignKFlag: boolean = false;
  KaryakartaData: any;
  partData = ["a", "b"]
  commonFormFilterObject = {};
  commonFormFilterInputParams: any = {};

  @Output() onSearchTriggered = new EventEmitter();
  @Output() onAddVisitorTriggered = new EventEmitter();
  @Output() onSubMenuTriggered = new EventEmitter();
  @Input() subIndex1
  @Input() receiveMessageValue
  selectedKaryakarta = [];
  message: string;
  assemblyData: Array<any>;
  sbc: any;

  constructor(
    private sessionService: SessionService,
    private utilityService: UtilityService,
    private karyakartaService: KaryakartaService,
    private service: VoterSearchAPIService
  ) {
    this.selectedVisitor = {};
  }
  reciverLastnames($event: string) {
    this.Lastname1 = $event;
  }

  initCommFilterParams() {
    this.commonFormFilterInputParams.genderTypes = GLOBAL_CONSTANT.GENDER_TYPES;
    this.commonFormFilterInputParams.boothData = this.sessionService.getTempJSStorage("BOOTH_DETAILS", false);
    // this.commonFormFilterInputParams = {
    //   genderTypes: GLOBAL_CONSTANT.GENDER_TYPES,
    //   boothData: this.sessionService.getTempJSStorage("BOOTH_DETAILS", false)
    // };
  }

  addVisitor() {
    this.onAddVisitorTriggered.emit({});
  }

  getIndexForMainMenu(index) {
    this.mainIndex = index;
    if (this.mainIndex !== 0) {
      this.subIndex = 0;
    }
    this.onSubMenuTriggered.emit({
      subIndex: this.subIndex,
      mainIndex: this.mainIndex,
    });
  }

  getIndexForSubMenu(index) {
    this.subIndex = index;
    this.onSubMenuTriggered.emit({
      subIndex: this.subIndex,
      mainIndex: this.mainIndex,
    });
  }

  getIndexForSubMenu2(index) {
    this.subIndex2 = index;
    this.onSubMenuTriggered.emit({
      subIndex: this.subIndex2,
      mainIndex: this.mainIndex,
    });
  }

  //new VS flow
  onSearchTriChild($event) {
    if ($event.type === "SAVE") {
      $event.data.type = undefined;
    }

    if ($event.actionMode === "RESET") {
      console.log("actionMode", $event.actionMode);
      this.commonFormFilterObject = {
        "gender": null,
        "ageFrom": null,
        "ageTo": null,
        "mobileNumberExists": null,
        "surveyStatus": null,
        "isPrintTaken": null,
        "boothName": null,
        "partNumber": null,
        "assembly": null
      };
    }


    this.onSearchTriggered.emit({
      data: this.utilityService.jsonParse($event.data),
    });
  }

  assignKarykrta() {
    this.getKarayakartaList();
    this.getPartData();
    this.assignKFlag = true;
  }

  getPartData() {
    //get part api
    // this.partData =
  }

  getKarayakartaList() {
    this.karyakartaService.getKaryakarta().subscribe((data) => {
      this.KaryakartaData = _.filter(
        data[0],
        function (e) {
          if (e.status) {
            return true;
          } else {
            false;
          }
        },
        this
      );
    });
  }

  savekarkrtaTemplate() {
    //save api
  }

  cancel(search) {
    this.selectedKaryakarta = null;
    this.assignKFlag = false;
  }

  getBoothData() {
    this.service.getBoothData().subscribe((res) => {
      this.sessionService.setTempJSStorage("BOOTH_DETAILS", res);
      this.initCommFilterParams();
    });
  }

  getAsseblyList() {
    this.service.getAssemblyData().subscribe((ele: any[]) => {
      this.commonFormFilterInputParams.assemblyData = ele.map(assembly => ({ label: assembly.name, value: assembly.id }));
    });
  }

  ngOnInit() {
    this.officeId = this.sessionService.getOffice();
    this.mainIndex = 0;
    this.getBoothData();
    this.getAsseblyList();

  }
}
